import React, {useMemo, useState} from 'react';
import {TagListUI} from './TagListUI';
import {AddToFavoritesButtonUI} from './AddToFavoritesButtonUI';
import TruncateTooltipUI from './TruncateTooltipUI';
import {AvailabilityUI} from './AvailabilityUI';
import {useNavigate} from 'react-router-dom';
import {useItemFavorite} from '../useItemFavorite';
import {toast} from 'react-toastify';
import {findItemAvailability, generateItemTags} from "../CatalogService";
import {buildDealTag} from '../domain/Tag.model.ts.js';

export const CatalogItemCard = ({ data, children, hasComboPromo = false }) => {
  const [isHovered, setIsHovered] = useState(false);

  const tags = useMemo(() => {
    return generateItemTags(data.catalogItem, hasComboPromo);
  }, [data.catalogItem, hasComboPromo]);

  const availability = useMemo(() => findItemAvailability(data.catalogItem), [data.catalogItem]);

  const { isFavorite, changeFavorite } = useItemFavorite(data.catalogItem);
  const navigate = useNavigate();

  const allChildren = React.Children.toArray(children);
  const priceComponent = allChildren.find(({ type }) => type === CatalogItemCard.Price);

  const handleFavoriteChange = async () => {
    try {
      await changeFavorite();
    } catch {
      toast.error('No se pudo añadir el producto a favoritos. Intentelo más tarde.');
    }
  };

  return (
    <div className="card border-0 shadow-sm"
         style={{ width: '270px', height: '390px', cursor: 'pointer' }}
         onClick={() => navigate(`/articulos/${encodeURIComponent(data.catalogItem.code)}`)}
         onMouseEnter={() => setIsHovered(true)}
         onMouseLeave={() => setIsHovered(false)}
    >
      <div className="card-header border-0 bg-white">
        <TagListUI data={{ tags }} />
      </div>

      <div className="card-img-top">
        <div className="d-flex justify-content-center align-items-center">
          <div className="position-absolute">
            <AddToFavoritesButtonUI
              data={{ showButton: isHovered, isFavorite: isFavorite }}
              actions={{ changeFavorite: handleFavoriteChange }}
            />
          </div>
          <img src={data.catalogItem.imageUrl}
               className="rounded-2 p-2"
               style={{ height: '170px', width: 'auto' }}
               alt="Imagen del producto"
          />
        </div>
      </div>

      <div className="card-body">
        <div className="d-flex flex-align-start flex-column h-100">
          <div className="h-100 mb-auto overflow-visible">
            <div className="card-title">
              <TruncateTooltipUI text={data.catalogItem.name} maxLength={40} />
            </div>

            <div className="card-subtitle text-muted">
              <small>{data.catalogItem.manufacturer}</small>
            </div>
          </div>

          <div className="card-text">
            <div className="d-flex flex-column gap-2">
              <AvailabilityUI data={{ availability }} />
              {priceComponent}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CatalogItemCard.Price = ({ children }) => children;

